import {
    BlotterFilteredOrdersState,
    initialBlotterFilteredOrdersState,
} from './BlotterFilteredOrdersState';
import {
    BlotterFilteredOrdersAction,
    BlotterFilteredOrdersActionType,
} from './actions';

export default function blotterFilteredOrdersReducer(
    state: BlotterFilteredOrdersState = initialBlotterFilteredOrdersState,
    action: BlotterFilteredOrdersAction
): BlotterFilteredOrdersState {
    switch (action.type) {
        case BlotterFilteredOrdersActionType.INCREMENT_RESULTS_TICK: {
            return {
                ...state,
                resultsTicks: state.resultsTicks + 1,
            };
        }
    }
    return state;
}
